import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/payroll-management-system/integration-with-accounting/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "integration-with-accounting" entry is kept); the seo block below is a fallback.

export const integrationWithAccounting: ContentPage = {
  slug: "payroll-management-system/integration-with-accounting",
  template: "hrmsFeature",
  seo: {
    title: "Integrate Payroll with Your Accounting Software",
    description: " Connect your payroll system with major accounting software to ensure accurate financial reporting and streamlined budget management.",
    keywords: [
      "payroll accounting integration",
      "financial data sync",
      "accounting software compatibility",
      "real-time payroll transfer",
      "payroll financial reporting.",
    ],
    ogImage: "/assets/data/seoimages/integration-with-accounting.webp",
  },
  leaf: {
    hero: {
      caption: "Integration with Accounting",
      title: "Seamlessly Integrate Payroll with Accounting Systems",
      description: "Sync your payroll data directly with your accounting software to streamline financial management and reporting.",
      h1: "caption",
    },
    split: {
      title: "Smooth Financial Data Integration",
      bullets: [
        { title: "Real-Time Data Sync", description: "Automatically sync payroll data after each cycle." },
        { title: "Instant Error-Free Updates", description: "Ensure updates are accurate and free from errors." },
        { title: "Accounting Software Compatibility", description: "Integrate seamlessly with major accounting platforms." },
        { title: "Comprehensive Financial Reporting", description: "Generate detailed reports for audits and analysis." },
      ],
      image: "/assets/images/img/product/hrms/payrollms/integration-with-accounting_info.webp",
      imageAlt: "integration-with-accounting_info",
    },
    cardsHeading: {
      title: "Key Features of Payroll Management System",
      description: "Optimize Payroll management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Overtime and Leave Calculations",
        href: "/hrms-software/payroll-management-system/overtime-leave-calculations",
        description: "Streamline how you handle overtime pay and leave deductions, ensuring fairness and compliance in your payroll processes.",
        image: "/assets/images/img/product/hrms/payrollms/overtime-leave-calculations.webp",
        imageAlt: "overtime-leave-calculations",
      },
      {
        title: "Payslip Generation",
        href: "/hrms-software/payroll-management-system/payslip-generation",
        description: "Provide clear and detailed payslips automatically each payroll cycle, enhancing transparency and trust with your employees.",
        image: "/assets/images/img/product/hrms/payrollms/payslip-generation_image.webp",
        imageAlt: "payslip-generation",
      },
      {
        title: "Custom Deductions",
        href: "/hrms-software/payroll-management-system/custom-deductions",
        description: "Tailor deductions for taxes, benefits, and other payroll elements to match your company policies and employee agreements.",
        image: "/assets/images/img/product/hrms/payrollms/custom-deductions.webp",
        imageAlt: "custom-deductions",
      },
      {
        title: "Tax and Compliance Management",
        href: "/hrms-software/payroll-management-system/tax-and-compliance-management",
        description: "Manage your payroll taxes and regulatory compliance effortlessly with our comprehensive tax management system.",
        image: "/assets/images/img/product/hrms/payrollms/tax-and-compliance-management_imge.webp",
        imageAlt: "tax-and-compliance-management",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Streamline Your Accounting with Integrated Payroll!",
    relatedBlogsKeyword: "hrms-accounting-integration,automated-payslip-generation",
    metaKey: "integration-with-accounting",
  },
  sections: [],
};
